import { deepCopy } from '../../../../../shared/utils/deepCopy';
import { ReduxAsyncActionsService } from '../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../types/ReduxAsyncActions.types';
import {
  APPLY_FILTERS,
  CLEAR_FILTER_EDITOR,
  type QrCodeLinkManagerFilterAction,
  REVERT_FILTER_EDITOR,
  UPDATE_ARCHIVED_FILTER,
  UPDATE_CAMPAIGN_FILTER,
  UPDATE_CHANNEL_FILTER,
  UPDATE_CREATED_DATE_RANGE_FILTER,
  UPDATE_FEATURE_FILTER,
  UPDATE_SEARCH_STRING_FILTER,
  UPDATE_TAGS_FILTER,
} from './actions';
import { INIT_FILTERS, INIT_STATE } from './constants';
import type { QrCodeLinkManagerFilterState } from './types';

const handler = (
  state: WrappedReducer<QrCodeLinkManagerFilterState>,
  action: QrCodeLinkManagerFilterAction
): WrappedReducer<QrCodeLinkManagerFilterState> => {
  switch (action.type) {
    case CLEAR_FILTER_EDITOR: {
      return {
        ...state,
        filterEditor: deepCopy(INIT_FILTERS),
      };
    }
    case REVERT_FILTER_EDITOR: {
      return {
        ...state,
        filterEditor: deepCopy(state.appliedFilters),
      };
    }
    case APPLY_FILTERS: {
      return {
        ...state,
        appliedFilters: deepCopy(state.filterEditor),
      };
    }
    case UPDATE_SEARCH_STRING_FILTER: {
      return { ...state, searchString: action.data.searchString };
    }
    case UPDATE_CREATED_DATE_RANGE_FILTER: {
      return {
        ...state,
        filterEditor: {
          ...state.filterEditor,
          createdDateRange: action.data.createdDateRange,
        },
      };
    }
    case UPDATE_ARCHIVED_FILTER: {
      return {
        ...state,
        filterEditor: {
          ...state.filterEditor,
          archived: action.data.archived,
        },
      };
    }
    case UPDATE_CAMPAIGN_FILTER: {
      return {
        ...state,
        filterEditor: {
          ...state.filterEditor,
          campaign: action.data.campaign,
        },
      };
    }
    case UPDATE_FEATURE_FILTER: {
      return {
        ...state,
        filterEditor: {
          ...state.filterEditor,
          feature: action.data.feature,
        },
      };
    }
    case UPDATE_CHANNEL_FILTER: {
      return {
        ...state,
        filterEditor: {
          ...state.filterEditor,
          channel: action.data.channel,
        },
      };
    }
    case UPDATE_TAGS_FILTER: {
      return {
        ...state,
        filterEditor: {
          ...state.filterEditor,
          tags: action.data.tags,
        },
      };
    }
    default: {
      return state;
    }
  }
};

const QrCodeLinkManagerFilterReducer = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {});

export default QrCodeLinkManagerFilterReducer;
